import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import RaportyService from "../RaportyService";
import TrasyService from "../../konfiguracja/trasyConfig/trasy/TrasyService";
import RaportZapelnieniaSearchbox from "./components/RaportZapelnieniaSearchbox";
import RaportZapelnieniaWykres from "./components/RaportZapelnieniaWykres";
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";
import RaportZapelnieniaTabela from "./components/RaportZapelnieniaTabela";

import Switch from "react-switch";
import LinieService from "../../konfiguracja/trasyConfig/linie/LinieService";

export default class RaportZapelnieniaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy: [],
            linie: [],

            nazwaTrasy:'',
            nazwaLini:'',

            arrDatowa: [],
            arrGodzinowa: [],

            loadingData: false,

            switchCzyGodzinowy: true // true - godzinowy, false - datowy
        };
    }

    componentDidMount() {
        this.pobierzTrasy()
        this.pobierzLinie()
    }

    pobierzTrasy = () => {
        TrasyService.getTrasy().then(response => {
            if (response) {
                if (response.data) {
                    if (response.data.content) {
                        this.setState({trasy: response.data.content})
                    }
                }
            }

        })
    }

    pobierzLinie = () =>{
        LinieService.getLinie().then(response=>{
            if(response)
                if(response.data)
                    if(response.data.content)
                        this.setState({linie:response.data.content})
        })
    }


    pobierzRaportZapelnienia = ({dataOd, dataDo, idTr,nazTr,idLi,nazLi}) => {
        this.setState({loadingData: true,nazwaTrasy:nazTr,nazwaLini:nazLi})
        RaportyService.pobierzRaportZapelnienia(dataOd, dataDo, idTr, idLi).then(response => {

            if(response.data.length>0)
            this.setState({loadingData: false, arrDatowa: response.data[0], arrGodzinowa: response.data[1]})
            else{
                this.setState({loadingData: false})
            }

        }).catch(err => this.setState({loadingData: false}))
    }


    render() {

        const iconStyles = {width:'100%',color:'#fff', textAlign: "center", fontSize:'20px',lineHeight:'28px'}

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'} style={{marginBottom: '5px'}}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {
                                        addressUrl: '/raporty/raport-zapelnienia',
                                        text: 'Raport zapełnienia'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <RaportZapelnieniaSearchbox handleClickSzukaj={this.pobierzRaportZapelnienia} trasy={this.state.trasy} linie={this.state.linie}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>

                            {
                                this.state.loadingData ?
                                    <div id={'smallLoader'}>
                                        <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                        <div>Trwa pobieranie danych...</div>
                                    </div>
                                    :
                                    <div>

                                        {
                                            (this.state.arrGodzinowa.length > 0 && this.state.arrDatowa.length > 0) &&
                                                <div>
                                                    <div style={{marginTop:"25px"}}>
                                                        <Row>
                                                            <Col xs={12} lg={2}>
                                                                <div>
                                                                    <span style={{fontStyle:'italic',color:'grey',fontSize:'12px', marginRight:'5px'}}>Wykres godzinowy</span>
                                                                    <Switch
                                                                        onChange={(switchCzyGodzinowy)=>this.setState({switchCzyGodzinowy})}
                                                                        checked={this.state.switchCzyGodzinowy}
                                                                        uncheckedIcon={<i className={"fa fa-calendar-o"} style={iconStyles}></i>}
                                                                        checkedIcon={<i className={"fa fa-clock-o"} style={iconStyles}></i>}
                                                                        onColor={'#83C33A'}

                                                                    />
                                                                    <span style={{fontStyle:'italic',color:'grey',fontSize:'12px', marginLeft:'5px'}}>Wykres datowy</span>
                                                                </div>
                                                            </Col>
                                                            <Col xs={12} lg={8}>
                                                                <h3 style={{textAlign:'center',margin:0}}>
                                                                    Wykres zapełnienia dla {(this.state.nazwaTrasy)? ('trasy '+this.state.nazwaTrasy):('lini '+this.state.nazwaLini)} względem {this.state.switchCzyGodzinowy?"godzin":"dat"}
                                                                </h3>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    {
                                                        this.state.switchCzyGodzinowy?
                                                            <div>
                                                                <RaportZapelnieniaWykres data={this.state.arrGodzinowa}/>
                                                                <RaportZapelnieniaTabela data={this.state.arrGodzinowa}/>
                                                            </div>
                                                            :
                                                            <div>
                                                                <RaportZapelnieniaWykres data={this.state.arrDatowa}/>
                                                                <RaportZapelnieniaTabela data={this.state.arrDatowa}/>
                                                            </div>
                                                    }
                                                </div>
                                        }
                                    </div>
                            }

                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RaportZapelnienia/RaportZapelnieniaContainer.js